{
  "title": "Налаштуйте школу",
  "description": "Чотири кроки перетворюють порожню школу на робочу. Щойно ви їх пройдете, ця картка зникне назавжди.",
  "progress": "Виконано {{done}} із {{total}}",
  "hide": "Сховати",
  "done": "Готово",
  "steps": {
    "class": {
      "label": "Створіть клас",
      "hint": "Клас — це група учнів, навколо якої відбувається все інше.",
      "action": "До класів"
    },
    "members": {
      "label": "Запросіть учасників",
      "hint": "Вчителі, учні та батьки приєднуються за запрошенням або за кодом класу.",
      "action": "До учасників"
    },
    "lesson": {
      "label": "Створіть перший урок",
      "hint": "Уроки живуть усередині курсу — відкрийте курс і додайте до нього урок.",
      "action": "До курсів"
    },
    "homework": {
      "label": "Задайте перше домашнє завдання",
      "hint": "Дайте класу завдання — і журнал оцінок почне наповнюватися сам.",
      "action": "До завдань"
    }
  }
}
